// import React, { useRef } from "react";
// import { Box, Typography, TextField, IconButton } from "@mui/material";
// import ContentCopyIcon from "@mui/icons-material/ContentCopy";
// import PrintIcon from "@mui/icons-material/Print";
// import { QRCodeCanvas } from "qrcode.react";

// const ExternalpagesTap = () => {
//   const subdomain = window.location.hostname.split(".")[0];
//   const url = `https://${subdomain}.restocash.app/ourmenu`;
//   const qrRef = useRef();

//   const handleCopy = () => {
//     navigator.clipboard.writeText(url);
//   };

//   const handlePrint = () => {
//     const canvas = qrRef.current.querySelector("canvas");
//     const dataUrl = canvas.toDataURL();
//     const win = window.open("", "_blank");
//     win.document.write(`<img src="${dataUrl}" style="width:300px;height:300px;display:block;margin:auto;" />`);
//     win.document.close();
//     win.focus();
//     win.print();
//   };

//   return (
//     <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", minHeight: "60vh", gap: 3 }}>
//       <Typography variant="h5" sx={{ mb: 2 }}>
//         رابط صفحة الطلبات الخارجية
//       </Typography>
//       <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//         <TextField 
//           value={url}
//           InputProps={{ readOnly: true }}
//           sx={{ width: 500 }}
//           variant="outlined"
//         />
//         <IconButton onClick={handleCopy} color="primary">
//           <ContentCopyIcon />
//         </IconButton>
//       </Box>
//       <Box sx={{ mt: 4, position: "relative" }} ref={qrRef}>
//         <QRCodeCanvas value={url} size={220} />
//         <IconButton
//           onClick={handlePrint}
//           color="primary"
//           sx={{
//             position: "absolute",
//             top: 10,
//             right: -50,
//             background: "#fff",
//             boxShadow: 1,
//           }}
//         >
//           <PrintIcon />
//         </IconButton>
//         <Typography sx={{ mt: 2, textAlign: "center" }}>
//           امسح الكود لفتح صفحة الطلبات
//         </Typography>
//       </Box>
//     </Box>
//   );
// };

// export default ExternalpagesTap;

import React, { useRef } from "react";
import { Box, Typography, TextField, IconButton, Alert } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import PrintIcon from "@mui/icons-material/Print";
import { QRCodeCanvas } from "qrcode.react";
import { useFeatures } from "../../../context/PermissionsAndFeatures/FeaturesContext";

const ExternalpagesTap = () => {
  const { hasFeature } = useFeatures();
  const qrRef = useRef();

  // تحقق من تفعيل الميزة
  const isFeatureEnabled =
    typeof hasFeature === "function"
      ? hasFeature("qr_customer_order")
      : hasFeature === undefined
      ? true
      : !!hasFeature;

  // في حالة أن الميزة غير مفعّلة
  if (!isFeatureEnabled) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "60vh",
        }}
      >
        <Alert severity="warning" sx={{ fontSize: "1.1rem", p: 2 }}>
          🚫 هذه الخدمة غير مفعّلة، برجاء التواصل مع الدعم الفني لتفعيلها.
        </Alert>
      </Box>
    );
  }

  const subdomain = window.location.hostname.split(".")[0];
  const url = `https://${subdomain}.restocash.app/ourmenu`;

  const handleCopy = () => {
    if (!navigator?.clipboard?.writeText) return;
    navigator.clipboard.writeText(url);
  };

  const handlePrint = () => {
    const canvas = qrRef.current?.querySelector?.("canvas");
    if (!canvas) return;
    const dataUrl = canvas.toDataURL();
    const win = window.open("", "_blank");
    if (!win) return;
    win.document.write(`
      <img src="${dataUrl}" style="width:300px;height:300px;display:block;margin:auto;" />
    `);
    win.document.close();
    win.focus();
    win.print();
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        minHeight: "60vh",
        gap: 3,
      }}
    >
      <Typography variant="h5" sx={{ mb: 2 }}>
        رابط صفحة الطلبات الخارجية
      </Typography>

      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <TextField
          value={url}
          InputProps={{ readOnly: true }}
          sx={{ width: 500 }}
          variant="outlined"
        />
        <IconButton onClick={handleCopy} color="primary">
          <ContentCopyIcon />
        </IconButton>
      </Box>

      <Box sx={{ mt: 4, position: "relative" }} ref={qrRef}>
        <QRCodeCanvas value={url} size={220} />
        <IconButton
          onClick={handlePrint}
          color="primary"
          sx={{
            position: "absolute",
            top: 10,
            right: -50,
            background: "#fff",
            boxShadow: 1,
          }}
        >
          <PrintIcon />
        </IconButton>
        <Typography sx={{ mt: 2, textAlign: "center" }}>
          امسح الكود لفتح صفحة الطلبات
        </Typography>
      </Box>
    </Box>
  );
};

export default ExternalpagesTap;
